
  import { defineComponent, ref } from 'vue'

  export default defineComponent({
    name: 'StatsMenu',
    emits: ['arrowClick', 'timeFrameUpdate'],
    setup(props, { emit }) {
      let selectedTimeFrame = ref('month')
      const timeFrames = ['week', 'month', 'year']

      function onUpdateTimeFrame(timeFrame: string) {
        selectedTimeFrame.value = timeFrame
        emit('timeFrameUpdate', timeFrame)
      }

      return {
        selectedTimeFrame,
        timeFrames,
        onUpdateTimeFrame,
        emit,
      }
    },
  })
